export default __webpack_public_path__ + "static/media/ub.5c2ab757.png";